import type { HyperlinkPluginOptions } from '@atlaskit/editor-plugin-hyperlink';

interface Props {
	options: Pick<
		HyperlinkPluginOptions,
		'editorAppearance' | 'linkPicker' | 'lpLinkPicker' | 'onClickCallback'
	>;
}

export function hyperlinkPluginOptions({ options }: Props): HyperlinkPluginOptions {
	return {
		editorAppearance: options.editorAppearance,
		lpLinkPicker: options.lpLinkPicker,
		linkPicker: options.linkPicker,
		onClickCallback: options.onClickCallback,
		platform: 'web',
	};
}
